var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7007,
    cy: 12.9995,
    r: 12.7007,
    fill: "#EDF2F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9234 9.11111C13.9234 8.49746 13.4259 8 12.8123 8C12.1986 8 11.7012 8.49746 11.7012 9.11111C11.7012 9.72476 12.1986 10.2222 12.8123 10.2222C13.4259 10.2222 13.9234 9.72476 13.9234 9.11111ZM13.9234 13C13.9234 12.3864 13.4259 11.8889 12.8123 11.8889C12.1986 11.8889 11.7012 12.3864 11.7012 13C11.7012 13.6136 12.1986 14.1111 12.8123 14.1111C13.4259 14.1111 13.9234 13.6136 13.9234 13ZM12.8123 15.7778C13.4259 15.7778 13.9234 16.2752 13.9234 16.8889C13.9234 17.5025 13.4259 18 12.8123 18C12.1986 18 11.7012 17.5025 11.7012 16.8889C11.7012 16.2752 12.1986 15.7778 12.8123 15.7778Z",
    fill: "#4B596C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableButton);
export default __webpack_public_path__ + "static/media/tableButton.f9890af5fa57493694c69d3397ca128d.svg";
export { ForwardRef as ReactComponent };